module.exports = __webpack_public_path__ + "static/img/04.b81691ec.png";